import { render } from "./OfferindexComponent.vue?vue&type=template&id=47f88df7"
import script from "./OfferindexComponent.vue?vue&type=script&lang=js"
export * from "./OfferindexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__